export function variantSupportsDescription(variant) {
    return ['container', 'default', 'footer'].includes(variant);
}
export function variantSupportsInteractiveElements(variant) {
    return ['container', 'compact'].includes(variant);
}
//# sourceMappingURL=utils.js.map